<template>
  <div class="input-show-hide-password">
    <input :type="type" :value="value" ref="inputPasswordRef"
           @input="$emit('input', $event.target.value)"
           :autocomplete="autocomplete"
           :required="required"
           :class="['form-control', extraClasses]"
           :placeholder="placeholder">

    <a href="#" :class="['btn-eye']"
       @click.prevent="toggleInputType">
      <Icon :name="isPassword ? 'eye' : 'eyeSlash'" width="18"/>
    </a>

  </div>

</template>

<script>
export default {
  name: "InputPassword",
  props: {
    value: {type: String, required: false},
    required: {type: Boolean, required: false},
    extraClasses: {type: String, required: false},
    placeholder: {type: String, required: false},
    autocomplete: {type: String, required: false},
  },
  data() {
    return {
      type: 'password'
    }
  },
  computed: {
    isPassword(){
      return this.type === 'password'
    }
  },
  methods: {
    toggleInputType() {
      this.type === 'password' ? this.type = 'text' : this.type = 'password'
      this.$refs.inputPasswordRef.focus()
    }
  }
}
</script>
